import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const navLinks = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影", end: false },
  { to: "/category/tv", label: "电视剧", end: false },
  { to: "/category/variety", label: "综艺", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function SiteNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "text-sm font-medium transition-colors whitespace-nowrap",
      isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600",
    ].join(" ");

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-site items-center gap-6 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-sm font-bold text-background-50">
            91
          </span>
          <span className="hidden font-heading text-base font-bold tracking-tight text-foreground-950 sm:block">
            {siteInfo.brand}
          </span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          {navLinks.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-1.5 lg:flex"
        >
          <i className="ri-search-line text-base text-foreground-500" />
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索片名 / 主演 / 导演"
            className="w-48 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-accent-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="打开菜单"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto max-w-site px-4 py-4">
            <form
              onSubmit={handleSearch}
              className="mb-4 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2"
            >
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索片名 / 主演 / 导演"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </form>
            <nav className="flex flex-col">
              {navLinks.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    [
                      "rounded-md px-3 py-2.5 text-sm font-medium",
                      isActive
                        ? "bg-primary-50 text-primary-700"
                        : "text-foreground-700",
                    ].join(" ")
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}